import PropTypes from 'prop-types';
import React from 'react';

import {
  ActionHeader,
  BlockView,
  Pagination,
  Price,
  Table,
} from 'components';

import ControlProductInfo from 'utils/project-definition/component/controls/ControlProductInfo';

const MAX_ITEMS_PER_PAGE = 6;

export default class ProductList extends React.Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.renderProduct = this.renderProduct.bind(this);
    this.clickProductHandler = this.clickProductHandler.bind(this);
    this.createBlockFromProduct = this.createBlockFromProduct.bind(this);
    this.paginationHandler = this.paginationHandler.bind(this);
    this.viewTypeHandler = this.viewTypeHandler.bind(this);
    this.tableRowHandler = this.tableRowHandler.bind(this);
    this.filterChangeHandler = this.filterChangeHandler.bind(this);
    this.sortChangeHandler = this.sortChangeHandler.bind(this);

    this.renderProductImageCell = this.renderProductImageCell.bind(this);
    this.renderProductNameCell = this.renderProductNameCell.bind(this);
    this.renderProductBrandCell = this.renderProductBrandCell.bind(this);
    this.renderProductPriceCell = this.renderProductPriceCell.bind(this);

    const FILTER_ALL = {
      value: 'all',
      label: this.getTranslation('general.status.all', 'All brands'),
    };
    this.FILTER_ALL = FILTER_ALL;

    const SORTING_NAME = {
      value: 'name',
      label: this.getTranslation('systems.sorting.leastRecent', 'Name'),
    };

    this.SORTING = [
      SORTING_NAME, {
        value: 'brand',
        label: this.getTranslation('systems.sorting.mostRecent', 'Brand'),
      },
    ];

    this.COLUMNS = [
      {
        // thumb
        accessor: 'image',
        cell: this.renderProductImageCell,
        // hidden: true,
        modifier: 'shrink',
      }, {
        // product
        accessor: 'name',
        cell: this.renderProductNameCell,
      }, {
        // brand
        accessor: 'brand',
        cell: this.renderProductBrandCell,
      }, {
        // price
        accessor: 'price',
        cell: this.renderProductPriceCell,
      },
    ];

    const DEFAULT_FILTER = FILTER_ALL;
    const DEFAULT_SORTING = SORTING_NAME;

    this.DEFAULT_FILTER = DEFAULT_FILTER;

    const products = this.filterDoubleProductIds(this.getProducts(props));
    this.state = {
      products,

      listSettings: {
        sorting: DEFAULT_SORTING,
        filter: DEFAULT_FILTER,
      },

      pagination: {
        pageIndex: 0,
        itemsPerPage: this.getMaxItemsPerPage(props),
        numPages: 0,
      },
      filteredProducts: null,
      visibleProducts: null,

      brandFilters: this.computeBrandFilters(products),
      viewType: 'blocks',
    };

    const { state } = this;
    const { pagination } = state;

    state.filteredProducts = this.computeFilteredProducts(products);
    pagination.numPages = this.computeNumPages(state.filteredProducts, props);
    state.visibleProducts = this.computeVisibleProducts(state.filteredProducts);
  }

  /* Methods */

  filterDoubleProductIds(products) {
    let result = products;
    const num = result ? result.length : 0;
    const map = {};
    for (let i = 0; i < num; i += 1) {
      const item = products[i];
      const prod = item ? item.product : null;
      const prodId = prod ? prod.id : -1;
      if (prodId !== null && typeof (prodId) !== 'undefined') {
        const prodIdStr = `${prodId}`;
        if (map[prodIdStr]) {
          if (result === products) {
            result = products.slice(0, i);
          }
        } else {
          map[prodIdStr] = true;
          if (result !== products) {
            result.push(item);
          }
        }
      }
    }
    return result;
  }

  componentWillReceiveProps(newProps) {
    const products = this.filterDoubleProductIds(this.getProducts(newProps));
    const newState = {};
    const { state } = this;
    const { pagination, listSettings } = this.state;

    if (products !== state.products) {
      newState.products = products;
      listSettings.filter = this.DEFAULT_FILTER;
      newState.brandFilters = this.computeBrandFilters(products);
      newState.filteredProducts = this.computeFilteredProducts(products);

      pagination.pageIndex = 0;
      pagination.numPages = this.computeNumPages(newState.filteredProducts, newProps);

      newState.visibleProducts = this.computeVisibleProducts(newState.filteredProducts);
    }

    newState.pagination = pagination;
    newState.listSettings = listSettings;

    this.setState(newState);
  }

  getProductInfo(value) {
    const productInfo = value;
    const { category } = this.props;
    if (category) {
      const { categoryName } = category;
      if (categoryName === 'control' || categoryName === 'controls' || categoryName === 'controller' || categoryName === 'controllers') {
        return value.control;
      }
    }
    return productInfo;
  }

  // Testing method
  getProducts1() {
    if (this.testProducts) {
      return this.testProducts;
    }
    this.testProducts = [
      {
        id: 0, control: { id: 0, brand: 'remeha', name: 'product E', price: 20, image: 'https://bgr-assets.s3.eu-west-1.amazonaws.com/remeha/products/100017393.png' }, controlSet: 'control-1',
      },
      {
        id: 1, control: { id: 1, brand: 'remeha', name: 'product C', price: 30, image: 'https://bgr-assets.s3.eu-west-1.amazonaws.com/remeha/products/100017393.png' }, controlSet: 'control-1',
      },
      {
        id: 2, control: { id: 2, brand: 'other', name: 'product A', price: 40, image: 'https://bgr-assets.s3.eu-west-1.amazonaws.com/remeha/products/100017393.png' }, controlSet: 'control-1',
      },
      {
        id: 3, control: { id: 3, brand: 'other', name: 'product D', price: 50, image: 'https://bgr-assets.s3.eu-west-1.amazonaws.com/remeha/products/100017393.png' }, controlSet: 'control-1',
      },
      {
        id: 4, control: { id: 4, brand: 'other', name: 'product B', price: 60, image: 'https://bgr-assets.s3.eu-west-1.amazonaws.com/remeha/products/100017393.png' }, controlSet: 'control-1',
      },
    ];
    return this.testProducts;
  }

  // The real method
  getProducts(propsParam) {
    if (propsParam) {
      return propsParam.products;
    }
    return this.props.products;
  }

  getPageIndex() {
    const { state } = this;
    if (state) {
      const { pagination } = state;
      if (pagination) {
        return pagination.pageIndex || 0;
      }
    }
    return 0;
  }

  getMaxItemsPerPage(props = null) {
    const { state } = this;
    if (state) {
      const { pagination } = state;
      if (pagination) {
        const { itemsPerPage } = pagination;
        if (typeof (itemsPerPage) === 'number') {
          return itemsPerPage;
        }
      }
    }
    const pr = props || this.props;
    const { itemsPerPage } = pr;
    if (typeof (itemsPerPage) === 'number') {
      return itemsPerPage;
    }

    return MAX_ITEMS_PER_PAGE;
  }

  computeNumPages(products, props) {
    const numProducts = products ? products.length : 0;
    const itemsPerPage = this.getMaxItemsPerPage(props);
    return Math.ceil(numProducts / itemsPerPage);
  }

  getBrandFilters() {
    return this.state.brandFilters;
  }

  getVisibleProducts() {
    const { state } = this;
    return state ? state.visibleProducts : null;
  }

  getFilteredProducts() {
    const { state } = this;
    return state ? state.filteredProducts : null;
  }

  updateFilteredProducts(products, state) {
    const result = state || {};
    result.filteredProducts = this.computeFilteredProducts(products);
    return result;
  }

  updateVisibleProducts(products, state) {
    const result = state || {};
    result.visibleProducts = this.computeVisibleProducts(products);
    return result;
  }

  computeVisibleProducts(products) {
    const numProducts = products ? products.length : 0;
    const itemsPerPage = this.getMaxItemsPerPage();

    if (numProducts <= itemsPerPage) {
      return products;
    }
    const pageIndex = this.getPageIndex();
    const startIndex = pageIndex * itemsPerPage;
    let endIndex = startIndex + itemsPerPage;
    endIndex = endIndex > numProducts ? numProducts : endIndex;

    return products.slice(startIndex, endIndex);
  }

  computeFilteredProducts(products) {
    const { listSettings: { filter, sort } } = this.state;

    const hasFilter = filter && filter.value !== this.FILTER_ALL.value;
    const hasSort = !!sort;

    if (!hasFilter && !hasSort) {
      return products;
    }
    let result = products;
    // Filter by brand
    if (hasFilter) {
      const filterValue = filter.value;
      result = result.filter((value) => {
        const productInfo = this.getProductInfo(value);
        const { brand } = productInfo;

        return filterValue === brand;
      });
    }

    if (hasSort) {
      // Sort by name / brand
      if (result === products) {
        result = result.concat();
      }
      const sortValue = sort.value;

      result.sort((item1, item2) => {
        const productInfo1 = this.getProductInfo(item1);
        const productInfo2 = this.getProductInfo(item2);
        const value1 = productInfo1[sortValue];
        const value2 = productInfo2[sortValue];
        if (value1 === value2) {
          return 0;
        }
        if (value1 < value2) {
          return -1;
        }
        return 1;
      });
    }

    return result;
  }

  computeBrandFilters(products) {
    const { FILTER_ALL } = this;
    const brandsArray = [];

    if (FILTER_ALL) {
      brandsArray.push(FILTER_ALL);
    }

    if (!products) {
      return brandsArray;
    }
    const brandsMap = {};
    for (let i = 0, length = products.length; i < length; i += 1) {
      const product = this.getProductInfo(products[i]);
      const brand = product ? product.brand : null;
      if (brand) {
        if (!brandsMap[brand]) {
          const filter = {
            value: brand,
            label: this.capitalize(brand),
          };
          brandsMap[brand] = filter;
          brandsArray.push(filter);
        }
      }
    }
    return brandsArray;
  }

  // TODO: get from util
  capitalize(string) {
    if (!string) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.substring(1, string.length);
  }

  getTranslation(key, fallback = null, props) {
    const p = props || this.props;
    const fallbackParam = fallback ? `${fallback}*` : null;
    const fb = fallbackParam || key;
    const { intl } = p;
    if (!intl) {
      return fb;
    }
    const { messages } = intl;
    if (!messages) {
      return fb;
    }
    const res = messages[key];
    if (typeof (res) === 'string') {
      return res;
    }
    return fb;
  }

  filterChangeHandler(value) {
    this.selectListSettingHandler(value, 'filter');
  }

  sortChangeHandler(value) {
    this.selectListSettingHandler(value, 'sort');
  }

  selectListSettingHandler(value, key) {
    const state = {};
    const { listSettings, pagination } = this.state;

    listSettings[key] = value;

    this.updateFilteredProducts(this.getProducts(), state);
    const { filteredProducts } = state;
    pagination.numPages = this.computeNumPages(filteredProducts, this.props);
    this.updateVisibleProducts(filteredProducts, state);

    state.listSettings = listSettings;
    this.setState(state);
  }

  tableRowHandler(productItem) {
    this.clickProductHandler(productItem);
  }

  viewTypeHandler(value) {
    this.setState({
      viewType: value,
    });
  }

  clickProductHandler(productItem) {
    const { onClickProduct, category } = this.props;
    if (onClickProduct) {
      const { data } = productItem;
      onClickProduct(data, category, this);
    }
  }

  paginationHandler(page) {
    const { pagination } = this.state;
    pagination.pageIndex = page - 1;
    const newState = { pagination };
    this.updateVisibleProducts(this.getFilteredProducts() || this.getProducts(), newState);
    this.setState(newState);
  }

  renderPrice(price) {
    return <Price value={price} />;
  }

  createBlockFromProduct(data) {
    let product = data;
    let id = product.id;
    if (data instanceof ControlProductInfo) {
      id = `${id}_${product.control_placement}_${data.set}`;
      product = data.product;
    }
    const { set_identifier, amount } = product;
    if (amount) {
      id = `${id}_${amount}`;
    }
    if (set_identifier) {
      id = `${id}_${set_identifier}`;
    }

    const price = (product.price || 0) * (product.amount || 1);

    return {
      id,
      data,
      product,
      price,
      onClick: this.clickProductHandler,
      subtitle: this.capitalize(product.brand),
      schema: product.image,
      title: this.capitalize(product.name),
    };
  }

  /* Render */

  // TODO: remove this method
  renderProduct(product) {
    const key = product.id;

    return (
      <div key={key}>
        product: {product.name}
      </div>
    );
  }

  renderEmptyList() {
    // TODO: translate
    return (
      <div>
        No products available
      </div>
    );
  }

  renderProductsOverview() {
    return (
      <div className="product-design-page__product-list__container">
        <div className="product-design-page__product-list__content">
          <div className="offset">{this.renderHeader()}</div>
          <div className="offset">{this.renderContent()}</div>
          <div className="offset offset--sm">{this.renderPagination()}</div>
          <div className="offset" />
        </div>
      </div>
    );
  }

  renderHeader() {
    const { listSettings: { filter, sort } } = this.state;
    return (
      <ActionHeader
        filterOptions={this.getBrandFilters()}
        onFilterChange={this.filterChangeHandler}
        onSortChange={this.sortChangeHandler}
        onViewChange={this.viewTypeHandler}
        selectedFilterOption={filter}
        selectedSortOption={sort}
        sortOptions={this.SORTING}
        viewType={this.state.viewType}
      />
    );
  }

  renderContent() {
    const { viewType } = this.state;
    const products = this.getVisibleProducts();

    if (!products) {
      return null;
    }

    let content = null;

    if (viewType === 'table') {
      content = this.renderTable();
    } else if (viewType === 'blocks') {
      content = this.renderBlockview();
    }

    return content;
  }

  renderTable() {
    const products = this.getVisibleProducts();
    const highlight = ''; // Still have to figure out if this is important
    const { sort } = this.state.listSettings;
    return (
      <Table
        columns={this.COLUMNS}
        defaultSorted={sort}
        highlight={highlight}
        noDataMessage={this.getTranslation('systems.overview.noData')}
        rows={products}
        rowClick={this.tableRowHandler}
        showHeader={false}
      />
    );
  }

  renderProductPropertyCell(value, property) {
    const { category } = this.props;
    const productInfo = this.getProductInfo(value);
    let product = productInfo;
    let set = null;
    let identifier = null;
    if (productInfo instanceof ControlProductInfo) {
      product = productInfo.product;
      set = productInfo.set;
    }
    identifier = product.set_identifier || '';
    const setName = set || '';
    const { id } = product;
    const categoryName = category ? category.categoryName : '';
    const key = `${categoryName}_${id}_${property}_${setName}_${identifier}`;

    let content = product[property];
    const modifier = `productlist-${property}-container`;

    if (property === 'image') {
      const imgURL = content;
      // TODO: class for img
      content = (
        <img style={{ height: '100%' }} src={imgURL} alt={product.name} />
      );
    } else if (property === 'price') {
      const amount = product.amount || 1;
      content = this.renderPrice(content * amount);
    }

    return (
      <div key={key} className={`table-body__cell__content table-body__cell--hightlight ${modifier}`}>
        {content}
      </div>
    );
  }

  renderProductImageCell(value) {
    return this.renderProductPropertyCell(value, 'image');
  }

  renderProductNameCell(value) {
    return this.renderProductPropertyCell(value, 'name');
  }

  renderProductBrandCell(value) {
    return this.renderProductPropertyCell(value, 'brand');
  }

  renderProductPriceCell(value) {
    return this.renderProductPropertyCell(value, 'price');
  }

  renderBlockview() {
    const products = this.getVisibleProducts();
    const productItems = products ? products.map(this.createBlockFromProduct) : null;
    const numProducts = productItems ? productItems.length : 0;
    if (!numProducts) {
      return this.renderEmptyList();
    }

    return (
      <BlockView data={productItems} />
    );
  }

  renderPagination() {
    // const { projects, pages } = this.state;
    const { pagination } = this.state;
    const pages = pagination.numPages;
    if (pages < 2) {
      return null;
    }
    const products = this.getProducts();

    const currentPage = pagination.pageIndex;

    if (products && products.length) {
      return (
        <Pagination
          amountPages={pages}
          currentPage={currentPage + 1}
          onChange={this.paginationHandler}
        />
      );
    }

    return null;
  }

  render() {
    return this.renderProductsOverview();
  }
}

ProductList.propTypes = {
  // availableProducts: PropTypes.array,
  products: PropTypes.array,
  category: PropTypes.object,
  onClickProduct: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/product-list/index.jsx